import {DictionaryObject} from '../../../../../../../common/api';
import {Observable} from 'rxjs/Rx';
import {Http} from '@angular/http';
import {Injectable} from '@angular/core';
import {AttachmentType} from '../../../../../../../clients/app/modules/+registration/api';

const ATTACHMENT_TYPE_URL = '/api/client/dictionary/attachment-type';

@Injectable()
export class AttachmentTypeService {

    constructor(private _http: Http) {

    }



    getAttachmentSubTypes(type: AttachmentType): Observable<Array<DictionaryObject>> {
        const URL = `${ATTACHMENT_TYPE_URL}/?type=${type}`;
        return this._http.get(URL)
            .map(response => response.json())
            .map(response => response.attachmentTypes);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/api/service/attachment-type-service.ts